import { createSlice } from '@reduxjs/toolkit';

// ─── Contact config ──────────────────────────────────────────────────────────
// Replace these two values before going live
export const WHATSAPP_NUMBER = '201500463555';
export const INSTAGRAM_HANDLE = 'YOUR_INSTAGRAM_HANDLE'; // e.g. 'lenses.store'
// ─────────────────────────────────────────────────────────────────────────────

const recalcTotals = (items) => ({
  totalCartPrice: items.reduce((t, i) => t + (i.product?.price || 0) * i.quantity, 0),
  numOfCartItems: items.reduce((t, i) => t + i.quantity, 0),
});

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: [],
    loading: false,
    error: null,
    totalCartPrice: 0,
    totalPriceAfterDiscount: null,
    numOfCartItems: 0,
    isInitialized: true,
    couponApplied: false,
    couponError: null,
    couponLoading: false,
  },
  reducers: {
    addItemToCart: (state, action) => {
      const { product, quantity = 1, leftEyePower = 0, rightEyePower = 0 } = action.payload;
      const existingIndex = state.items.findIndex(
        (item) =>
          item.product._id === product._id &&
          item.leftEyePower === leftEyePower &&
          item.rightEyePower === rightEyePower
      );
      if (existingIndex >= 0) {
        state.items[existingIndex].quantity += quantity;
      } else {
        state.items.push({
          _id: `${product._id}_${Date.now()}`,
          product,
          quantity,
          leftEyePower,
          rightEyePower,
        });
      }
      const totals = recalcTotals(state.items);
      state.totalCartPrice = totals.totalCartPrice;
      state.numOfCartItems = totals.numOfCartItems;
    },

    removeCartItem: (state, action) => {
      state.items = state.items.filter((item) => item._id !== action.payload);
      const totals = recalcTotals(state.items);
      state.totalCartPrice = totals.totalCartPrice;
      state.numOfCartItems = totals.numOfCartItems;
    },

    updateCartItemQuantity: (state, action) => {
      const { cartItemId, quantity } = action.payload;
      const item = state.items.find((i) => i._id === cartItemId);
      if (item && quantity > 0) item.quantity = quantity;
      const totals = recalcTotals(state.items);
      state.totalCartPrice = totals.totalCartPrice;
      state.numOfCartItems = totals.numOfCartItems;
    },

    clearCart: (state) => {
      state.items = [];
      state.totalCartPrice = 0;
      state.numOfCartItems = 0;
      state.totalPriceAfterDiscount = null;
      state.couponApplied = false;
    },

    // Kept for compatibility with existing imports
    clearCouponError: (state) => {
      state.couponError = null;
      state.couponLoading = false;
    },
    resetCouponState: (state) => {
      state.couponError = null;
      state.couponLoading = false;
      state.couponApplied = false;
      state.totalPriceAfterDiscount = null;
    },
    resetAllStates: (state) => {
      state.error = null;
      state.couponError = null;
      state.couponLoading = false;
    },
    updateCartCount: (state, action) => {
      state.numOfCartItems = action.payload;
    },
  },
});

export const {
  addItemToCart,
  removeCartItem,
  updateCartItemQuantity,
  clearCart,
  clearCouponError,
  resetCouponState,
  resetAllStates,
  updateCartCount,
} = cartSlice.actions;

export default cartSlice.reducer;
